import React, { memo } from 'react';

const StatusInner = () => (
    <svg viewBox="0 0 14 16">
        <path d="M5 2C5.6 2 6 2.4 6 3V15C6 15.6 5.6 16 5 16C4.4 16 4 15.6 4 15V3C4 2.4 4.4 2 5 2ZM9 4C9.6 4 10 4.4 10 5V15C10 15.6 9.6 16 9 16C8.4 16 8 15.6 8 15V5C8 4.4 8.4 4 9 4ZM13 0C13.6 0 14 0.4 14 1V15C14 15.6 13.6 16 13 16C12.4 16 12 15.6 12 15V1C12 0.4 12.4 0 13 0ZM1 8C1.6 8 2 8.4 2 9V15C2 15.6 1.6 16 1 16C0.4 16 0 15.6 0 15V9C0 8.4 0.4 8 1 8Z" />
    </svg>
);

export const Status = memo(StatusInner);
